export default "__VITE_ASSET__cxCVw6og__"